<div id="rightMenuContainer" >
	
	<div id="rightMenuComponent"  >
		
		
		<div class="container" style="padding-left: 0%;padding-right: 0%;height:15%" (click)="sendMessageForRaiseHand();">
			<div class="card text-center h-100">
				<img class="card-img-top smallimg mx-auto" src="assets/images/Rise_Hand.png" alt="Card image cap">
				<div class="card-block catCard">
					<h2 class="card-title">Raise Hand</h2>
				</div>
				
			</div>
		</div>
		<div class="container" style="padding-left: 0%;padding-right: 0%;height:2%"></div>
		<div class="container" style="padding-left: 0%;padding-right: 0%;height:15%">
			<div class="card text-center h-100">
				<img class="card-img-top smallimg mx-auto" src="assets/images/like.png" alt="Card image cap">
				<div class="card-block catCard">
					<h2 class="card-title">Like</h2>
				</div>
				
			</div>
		</div>
		<div class="container" style="padding-left: 0%;padding-right: 0%;height:2%"></div>
		<div class="container" style="padding-left: 0%;padding-right: 0%;height:15%" (click)="toggleChat()">
			<div class="card text-center h-100">
				<img class="card-img-top smallimg mx-auto" src="assets/images/Chate.png" alt="Card image cap">
				<div class="card-block catCard">
					<h2 class="card-title">Chat</h2>
				</div>
				
			</div>
		</div>
		<div class="container" style="padding-left: 0%;padding-right: 0%;height:2%"></div>
		<div class="container" style="padding-left: 0%;padding-right: 0%;height:15%" (click)="sendMessageForAllSubscriber()">
			<div class="card text-center h-100">
				<img class="card-img-top smallimg mx-auto" src="assets/images/leave.png" alt="Card image cap">
				<div class="card-block catCard">
					<h2 class="card-title">Leave</h2>
				</div>
				
			</div>
		</div>

	</div>
	<!--new sandep-->
	<div id="rightMenuComponentnew"    >
		
		
		<div class="container2" style="padding-left: 0%;padding-right: 0%;height:22%" *ngFor="let user of remoteUsersForPart"  (mouseover)="isShowRemoteControls[user.nickname]=true;removeRaiseHand(user.nickname);" (mouseout)="isShowRemoteControls[user.nickname]=false">
			<div class="card text-center h-100" style="width: 104px;" [ngClass]="{'blink_me':(raiseHandUserList.indexOf(user.nickname) > -1)}" >
				<img class="card-img-top smallimg mx-auto" src="{{user.randomAvatar}}" alt="Card image cap">
				<button class="btn1" [hidden]="!isShowRemoteControls[user.nickname]" (click)="setRemoteUserConnectionID(user.nickname,user.connectionId)" *ngIf="!isView[user.nickname]"><mat-icon >visibility</mat-icon></button>
				<button class="btn1" [hidden]="!isShowRemoteControls[user.nickname]" (click)="setRemoteUserConnectionID(user.nickname,user.connectionId)" *ngIf="isView[user.nickname]"><mat-icon >visibility_off</mat-icon></button>
				<button class="btn2" [hidden]="!isShowRemoteControls[user.nickname]" (click)="sendMessageForMute(user.nickname);isMute[user.nickname]=true;" *ngIf="!isMute[user.nickname]"><mat-icon >volume_up</mat-icon></button>
				<button class="btn2" [hidden]="!isShowRemoteControls[user.nickname]" (click)="sendMessageForMute(user.nickname);isMute[user.nickname]=false;" *ngIf="isMute[user.nickname]"><mat-icon >volume_off</mat-icon></button>
				<button class="btn3" [hidden]="!isShowRemoteControls[user.nickname]" (click)="sendMessageForForceDisconnect(user.nickname)"><mat-icon >delete</mat-icon></button>
				<button class="btn4" [hidden]="!isShowRemoteControls[user.nickname]" (click)="sendMessageForForceDisconnect(user.nickname)"><mat-icon > delete_forever</mat-icon></button>
				<div class="card-block catCard">
					
					<h4 class="card-title">{{user.nickname}}</h4>
				</div>
				
			</div>
		</div>
		<div class="container" style="padding-left: 0%;padding-right: 0%;height:2%"></div>
	
	

	</div>
</div>
